const fileToBase64 = (file: Blob) => {
  return new Promise<string>((resolve) => {
    const reader = new FileReader();
    reader.onloadend = (e: any) => resolve(e.target.result);
    reader.readAsDataURL(file);
  });
};

const base64ToImage = (dataURL: string) => {
  return new Promise<HTMLImageElement>((resolve) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.src = dataURL;
  });
};

const canvasToFile = (canvas: any, type: string, quality: number) => {
  return new Promise<Blob>((resolve) =>
    canvas.toBlob((blob: Blob) => resolve(blob), type, quality)
  );
};

export async function compressImage(file: File, quality: number) {
  let fileName = file.name;
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d")!;
  const base64 = await fileToBase64(file);
  const img = await base64ToImage(base64);
  canvas.width = img.width;
  canvas.height = img.height;

  context.clearRect(0, 0, img.width, img.height);
  context.drawImage(img, 0, 0, img.width, img.height);

  let blob = await canvasToFile(canvas, file.type, quality); //quality:0.5可根据实际情况计算
  return new File([blob], fileName, { type: file.type });
}
